<template>
  <div class="echartBox" ref="echartBox"></div>
</template>

<script lang="ts" setup>
import * as echarts from 'echarts'
import { onMounted, onUnmounted, shallowRef, watch } from 'vue'

const props = defineProps<{
  option: echarts.EChartsOption
}>()

const echartBox = shallowRef() // 获取echartBox
let myChart: echarts.ECharts | undefined = undefined // 获取echart实例

onMounted(() => {
  myChart = echarts.init(echartBox.value)
  setOption(props.option)
  window.addEventListener('resize', resizeByParent)
})

/**
 * 设置echart的option
 * @param option
 */
const setOption = (option: echarts.EChartsOption) => {
  myChart && myChart.setOption(option)
}

/** 重置Echarts大小  */
const resizeByParent = () => {
  myChart && myChart.resize()
}

watch(
  () => props.option,
  (newOption) => {
    setOption(newOption)
  }
)

onUnmounted(() => {
  window.removeEventListener('resize', resizeByParent)
  myChart && myChart.dispose()
})
</script>

<style>
.echartBox {
  width: 303px;
  height: 203px;
  box-sizing: border-box;
}
</style>
